import type { PropsWithChildren } from 'react';
import { createContext, useMemo } from 'react';
import { useContextOrThrow } from '@elfsight/lib-utils';
import type { CheckoutItemProps } from '../blocks';
import type { CheckoutSummaryProps } from '../layouts';

const CheckoutItemContext = createContext<CheckoutItemProps | null>(null);

export type CheckoutItemProviderProps = {
  summarySettings: CheckoutSummaryProps;
};

export function CheckoutItemProvider({
  summarySettings: { productCard, totalPrice },
  children
}: PropsWithChildren<CheckoutItemProviderProps>) {
  const checkoutItem = useMemo(
    () => ({
      label: productCard?.label,
      price: totalPrice,
      imageSrc: productCard?.imageSrc
    }),
    [productCard, totalPrice]
  );

  return (
    <CheckoutItemContext.Provider value={checkoutItem}>
      {children}
    </CheckoutItemContext.Provider>
  );
}

export function useCheckoutItem() {
  return useContextOrThrow(CheckoutItemContext, 'CheckoutItem');
}
